// /app/frontend/src/config.js
// Production-safe: always use same-origin routing via nginx proxy
const BACKEND_URL = window.location.origin;
export const API = `${BACKEND_URL}/api`;
